import React from "react";

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="section" style={{ background: 'var(--gradient-primary)', color: 'white', paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="container text-center">
          <h1 style={{ color: 'white', fontSize: '3rem', marginBottom: '1.5rem' }}>
            About <span style={{ color: 'var(--primary-green)' }}>VissdaTech</span>
          </h1>
          <p style={{
            fontSize: '1.25rem',
            maxWidth: '800px',
            margin: '0 auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.7
          }}>
            Pioneering the future of business software with innovative SaaS solutions that empower organizations to achieve their full potential.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'center', gap: '4rem' }}>
            <div>
              <h2 style={{ marginBottom: '2rem' }}>Our Mission</h2>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.7, marginBottom: '2rem' }}>
                To democratize enterprise-grade software solutions by making them accessible, affordable, and easy to implement for businesses of all sizes. We believe that every organization deserves access to powerful tools that can drive growth and efficiency.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {missionPoints.map((point, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      background: 'var(--gradient-accent)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      marginTop: '0.125rem'
                    }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                        <polyline points="20,6 9,17 4,12"></polyline>
                      </svg>
                    </div>
                    <span style={{ color: 'var(--gray-700)' }}>{point}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="card" style={{ padding: '3rem', background: 'var(--gray-50)', border: 'none' }}>
              <h3 style={{ color: 'var(--primary-green)', marginBottom: '1.5rem' }}>Our Vision</h3>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.7, color: 'var(--gray-700)' }}>
                To be the global leader in SaaS innovation, setting new standards for user experience, security, and business value. We envision a world where technology seamlessly integrates with business processes to create unprecedented opportunities for growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Our Story</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              From a small startup to a trusted partner for businesses worldwide
            </p>
          </div>

          <div className="grid grid-2" style={{ gap: '3rem' }}>
            <div>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.7, marginBottom: '2rem' }}>
                Founded in 2025, VissdaTech emerged from a simple observation: businesses were struggling with fragmented software solutions that didn't communicate with each other, leading to inefficiencies and missed opportunities.
              </p>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.7, marginBottom: '2rem' }}>
                Our founders, with combined decades of experience in enterprise software and emerging technologies, set out to create integrated SaaS solutions that could adapt to any business model while maintaining the highest standards of security and performance.
              </p>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.7 }}>
                Today, we serve over 500 businesses across various industries, from startups to Fortune 500 companies, helping them streamline operations and accelerate growth through our innovative technology platforms.
              </p>
            </div>
            <div>
              <div className="card" style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <h3 style={{ color: 'var(--primary-green)', fontSize: '2rem', marginBottom: '0.5rem' }}>2022</h3>
                <p style={{ fontWeight: 600, marginBottom: '1rem' }}>Company Founded</p>
                <p style={{ color: 'var(--gray-600)' }}>VissdaTech established in Sheridan, Wyoming</p>
              </div>
              <div className="card" style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <h3 style={{ color: 'var(--accent-green-bright)', fontSize: '2rem', marginBottom: '0.5rem' }}>500+</h3>
                <p style={{ fontWeight: 600, marginBottom: '1rem' }}>Clients Served</p>
                <p style={{ color: 'var(--gray-600)' }}>Businesses transformed across multiple industries</p>
              </div>
              <div className="card" style={{ textAlign: 'center' }}>
                <h3 style={{ color: 'var(--primary-black)', fontSize: '2rem', marginBottom: '0.5rem' }}>24/7</h3>
                <p style={{ fontWeight: 600, marginBottom: '1rem' }}>Support Coverage</p>
                <p style={{ color: 'var(--gray-600)' }}>Round-the-clock assistance for our clients</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Our Core Values</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-3">
            {values.map((value, index) => (
              <div key={index} className="card text-center">
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '1.5rem',
                  background: 'var(--gradient-accent)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  {value.icon}
                </div>
                <h3 style={{ marginBottom: '1rem', color: 'var(--primary-green)' }}>{value.title}</h3>
                <p style={{ color: 'var(--gray-600)' }}>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    

      {/* Company Info */}
      <section className="section">
        <div className="container">
          <div className="card" style={{
            background: 'var(--gradient-hero)',
            color: 'white',
            padding: '3rem',
            border: 'none'
          }}>
            <div className="grid grid-2" style={{ alignItems: 'center', gap: '3rem' }}>
              <div>
                <h2 style={{ color: 'white', marginBottom: '2rem' }}>Company Information</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <strong>Founded:</strong> 2025
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                    <strong>Headquarters:</strong>
                    <span>30 N Gould St Ste N, Sheridan, SHERIDAN COUNTY, WY 82801 USA</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <strong>Industry Focus:</strong> SaaS Solutions, Business Automation
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <strong>Specialties:</strong> Custom Application Development, Integration Services
                  </div>
                </div>
              </div>
              <div>
                <h3 style={{ color: 'var(--primary-green)', marginBottom: '1.5rem' }}>Our Commitment</h3>
                <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: 1.7 }}>
                  We believe in innovation, integrity, and delivering measurable value to our clients. Every solution we create is designed with your success in mind, backed by our commitment to excellence and continuous improvement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const missionPoints = [
  "Deliver cutting-edge SaaS solutions that drive real business value",
  "Maintain the highest standards of security and data protection",
  "Provide exceptional customer support and ongoing partnership",
  "Foster innovation through continuous technology advancement"
];

const values = [
  {
    icon: "🎯",
    title: "Innovation",
    description: "We continuously push the boundaries of what's possible, embracing new technologies and methodologies to deliver breakthrough solutions."
  },
  {
    icon: "🤝",
    title: "Integrity",
    description: "We operate with complete transparency and honesty, building trust through consistent actions and ethical business practices."
  },
  {
    icon: "⭐",
    title: "Excellence",
    description: "We strive for perfection in everything we do, from code quality to customer service, never settling for 'good enough'."
  },
  {
    icon: "👥",
    title: "Collaboration",
    description: "We believe in the power of partnership, working closely with our clients to understand their unique needs and challenges."
  },
  {
    icon: "🚀",
    title: "Growth",
    description: "We're committed to helping our clients grow while continuously evolving our own capabilities and services."
  },
  {
    icon: "🔒",
    title: "Security",
    description: "We prioritize data protection and privacy, implementing industry-leading security measures in all our solutions."
  }
];

const team = [
  {
    name: "Alex Johnson",
    role: "Chief Executive Officer",
    bio: "15+ years in enterprise software development and business strategy. Led multiple successful SaaS implementations.",
    avatar: "👨‍💼"
  },
  {
    name: "Sarah Chen",
    role: "Chief Technology Officer",
    bio: "Expert in cloud architecture and scalable systems. Former senior architect at leading tech companies.",
    avatar: "👩‍💻"
  },
  {
    name: "Michael Rodriguez",
    role: "Head of Customer Success",
    bio: "Passionate about client relationships and ensuring successful software implementations across industries.",
    avatar: "👨‍🎯"
  }
];

export default About;